import React from 'react'
import { bannerImg } from "../../assets/index";

const RightBanner = () => {
  return (
    <div className="w-full lgl:w-1/2 flex justify-center items-center relative">
      <img
        className="w-[550px] h-[470px] lgl:w-[550px] lgl:h-[800px] z-10"
        src={bannerImg}
        alt="bannerImg"
      />
      <div className="absolute bottom-0 w-[300px] h-[250px] lgl:w-[500px] lgl:h-[500px] bg-gradient-to-r from-[#32494b] to-[#283a3c] shadow-shadowOne flex justify-center items-center"></div>
    </div>
  );
}

export default RightBanner